<template>
  <div id="shop-order-list">
    <v-container grid-list-xl>
      <v-layout align-center row wrap>
        <v-flex sm7 xs12>
          <div class="headline">Order List</div>
        </v-flex>
        <v-flex sm3 xs12>
          <v-text-field clearable label="ค้นหา" single-line v-model="searchText"></v-text-field>
        </v-flex>
        <v-flex sm2 text-xs-center xs12>
          <ShopOrderListDialog />
        </v-flex>
        <v-flex xs12>
          <!-- Data Table -->
          <v-data-table
            class="elevation-0"
            disable-initial-sort
            :headers="headers"
            hide-actions
            :items="states"
            :loading="tableLoading"
            :search="searchText"
          >
            <template slot="items" slot-scope="props">
              <tr @click="editItem(props.item.idx)">
                <!-- <td>{{ props.item.idx }}</td> -->
                <td>{{ mapProductName(props.item.productId) }}</td>
                <td>{{ props.item.quantity }}</td>
                <td>{{ props.item.totalPrice }}</td>
                <td>{{ `${props.item.firstname} ${props.item.lastname}` }}</td>
                <td>{{ props.item.phone }}</td>
                <td>{{ mapProvinceName(props.item.province) }}</td>
                <!-- <td>{{ props.item.district }}</td> -->
                <!-- <td>{{ props.item.subDistrict }}</td> -->
                <td>
                  <v-icon :color="props.item.transferSlip ? 'green' : 'red'">
                    {{ props.item.transferSlip ? 'done' : 'close' }}
                  </v-icon>
                </td>
                <td>{{ props.item.status }}</td>
                <td>{{ props.item.createdAt }}</td>
                <!-- <td>{{ props.item.note }}</td> -->
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import store from '@/store'

import ShopOrderListDialog from '@/components/admin/ShopOrderListDialog'
export default {
  name: 'shop-order-list',
  components: {
    ShopOrderListDialog
  },
  data() {
    return {
      searchText: '',
      users: [],
      searchPhone: '',
      searchTopic: '',
      // Table
      tableLoading: false,
      headers: [
        // { text: 'ID', align: 'left', value: 'idx', width: '10' },
        { text: 'Product', align: 'left', value: 'productId', width: '200' },
        { text: 'Qua', align: 'left', value: 'quantity', width: '10' },
        { text: 'Total Price', align: 'left', value: 'totalPrice', width: '200' },
        { text: 'Name', align: 'left', value: 'firstname', width: '400' },
        { text: 'Phone', align: 'left', value: 'phone', width: '200' },
        { text: 'Province', align: 'left', value: 'province', width: '200' },
        // { text: 'District', align: 'left', value: 'district', width: '200' },
        // { text: 'Sub District', align: 'left', value: 'subDistrict', width: '200' },
        { text: 'Slip', align: 'left', value: 'transferSlip', width: '10' },
        { text: 'Status', align: 'left', value: 'status', width: '200' },
        { text: 'Create Date', align: 'left', value: 'creatdAt', width: '300' }
        // { text: 'Note', align: 'left', value: 'note', width: '200' }
      ]
    }
  },
  beforeRouteEnter: (to, from, next) => {
    store.state.ShopOrderList.data.length === 0 // main fetch
      ? store.dispatch('ShopOrderList/fetch').then(next())
      : next()
    if (store.state.ShopEdition.data.length === 0) store.dispatch('ShopEdition/fetch')
    if (store.state.ShopEditionProduct.data.length === 0) store.dispatch('ShopEditionProduct/fetch')
    if (store.state.ShopEditionProductItem.data.length === 0)
      store.dispatch('ShopEditionProductItem/fetch')
    if (store.state.ShopEditionProductItemPrice.data.length === 0)
      store.dispatch('ShopEditionProductItemPrice/fetch')
    if (store.state.Product.nameProducts.length === 0) store.dispatch('Product/fetchProductName')
  },
  computed: {
    states() {
      return this.$store.getters['ShopOrderList/getAll']
    }
  },
  created() {},
  methods: {
    editItem(idx) {
      this.$store.commit('ShopOrderList/UPDATE_DIALOG', true)
      this.$store.commit('ShopOrderList/SET_IDX', idx)
    },
    mapProvinceName(idx) {
      return this.$store.getters['Place/getProvinceAll']
        .filter(item => item.id == idx)
        .map(item => item.nametha)
        .toString()
    },
    mapProductName(idx) {
      return this.$store.state.Product.nameProducts
        .filter(item => item.productid == idx)
        .map(item => item.productname)[0]
    }
  }
}
</script>

<style lang="scss" scoped></style>
